import { IAvatar } from '../../common/utils/interfaces';
import { AvatarGroup } from '@mui/material';
import AvatarImage from '../../common/avatar-image';

interface Props {
  members: IAvatar[];
  max: number;
}

const AvatarGroupForProjects = ({ members, max }: Props): JSX.Element => {
  const visibleAvatars = members.slice(0, max);

  return (
    <AvatarGroup
      data-testid={'avatar-group'}
      max={max}
      sx={{
        '& .MuiAvatar-root': {
          border: '1px',
          width: {
            xs: '24px',
            sm: '27px',
            md: '28px'
          },
          height: {
            xs: '24px',
            sm: '27px',
            md: '28px'
          }
        }
      }}
    >
      {visibleAvatars.map((member) => (
        <AvatarImage
          key={member.providerId}
          providerId={member.providerId ?? ''}
          alt={member.displayName}
        />
      ))}
    </AvatarGroup>
  );
};

export default AvatarGroupForProjects;
